import { render, staticRenderFns } from "./ProfesorTaller.vue?vue&type=template&id=05ac5a52"
import script from "./ProfesorTaller.vue?vue&type=script&lang=js"
export * from "./ProfesorTaller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports